import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const CollapsibleSection = ({ title, isOpen, onToggle, children, sectionId }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={() => onToggle(sectionId)}
      className="w-full flex items-center justify-between py-4 px-6 hover:bg-gray-50 transition-colors"
    >
      <h3 className="text-[15px] font-semibold text-gray-900">{title}</h3>
      {isOpen ? (
        <ChevronUp className="h-5 text-gray-600" />
      ) : (
        <ChevronDown className="h-5 text-gray-600" />
      )}
    </button>
    {isOpen && <div className="px-6 pb-6">{children}</div>}
  </div>
);

export default CollapsibleSection;